import WorkerCardLarge from "./WorkerCardLarge";

export default WorkerCardLarge;
